import React, { useState } from "react";
import { Waypoint } from "react-waypoint";

const Skills = () => {
  const skills = [
    { name: "Market Research", value: 95 },
    { name: "Data Analysis", value: 90 },
    { name: "Data Visualization", value: 80 },
    { name: "Business Intelligence", value: 85 },
    { name: "Team Leadership", value: 90 },
    { name: "Project Management", value: 85 },
    { name: "Python Data Analysis", value: 95 },
    { name: "SQL", value: 90 },
    { name: "React Web Development", value: 85 },
    { name: "Machine Learning Algorithms", value: 55 },
  ];

  const [inView, setInView] = useState(false);

  const handleEnterViewport = () => {
    setInView(true);
  };

  const handleLeaveViewport = () => {
    setInView(false);
  };

  return (
    <section id="skills" className="skills section-bg">
      <div className="container">
        <div className="section-title">
          <h2>Skills</h2>
          <p>
            With over 20 years of expertise in research, data analysis, web development, and software engineering, I bring a wealth of skills to the table. From spearheading innovative marketing research initiatives to developing secure and performance-optimized web applications, my abilities are finely honed to achieve goals efficiently and effectively. With a strong understanding of system architecture and software engineering principles, coupled with excellent problem-solving skills, I am uniquely positioned to deliver tangible results that drive success. Explore my portfolio to see how my skills can benefit your projects and goals.
          </p>
        </div>

        <div className="row skills-content">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="col-lg-6"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="progress">
                <span className="skill">
                  {skill.name} <i className="val">{skill.value}%</i>
                </span>
                <div
                  className="progress-bar"
                  role="progressbar"
                  aria-valuenow={inView ? skill.value : 0}
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: `${inView ? skill.value : 0}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Waypoint
        onEnter={handleEnterViewport}
        onLeave={handleLeaveViewport}
        Offset="80%"
      />
    </section>
  );
};

export default Skills;
